import { Component } from "react";

const hasViteOverlay =
  typeof customElements !== "undefined" &&
  Boolean(customElements.get("vite-error-overlay"));

if (hasViteOverlay) {
  window.onerror = (event, source, lineno, colno, err) => {
    const ErrorOverlay = customElements.get("vite-error-overlay");
    if (!ErrorOverlay) return;
    const overlay = new ErrorOverlay(err);
    document.body.appendChild(overlay);
  };
}

export default class DevErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (!hasViteOverlay) return;
    const ErrorOverlay = customElements.get("vite-error-overlay");
    if (!ErrorOverlay) return;
    const overlay = new ErrorOverlay(error);
    document.body.appendChild(overlay);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
